import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=59ae7d93&"
import script from "./Empty.vue?vue&type=script&lang=js&"
export * from "./Empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ae7d93')) {
      api.createRecord('59ae7d93', component.options)
    } else {
      api.reload('59ae7d93', component.options)
    }
    module.hot.accept("./Empty.vue?vue&type=template&id=59ae7d93&", function () {
      api.rerender('59ae7d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Empty.vue"
export default component.exports